import React, { useEffect, useState } from "react";
import { MdOutlineCloudDownload } from "react-icons/md";
import { toast } from "react-hot-toast";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import Layout from "../Layout";
import { Button, Select } from "../components/Form";
import { ServiceTable } from "../components/Tables";
import { sortsDatas } from "../components/Datas";
import AddEditServiceModal from "../components/Modals/AddEditServiceModal";
import servicesService from "../api/servicesService";

function Services() {
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState({});
  const [status, setStatus] = useState(sortsDatas.service[0]);
  const [services, setServices] = useState([]);
  const [search, setSearch] = useState("");

  const fetchServices = async () => {
    try {
      const res = await servicesService.getAllServices(search, status.name);
      if (res.success) {
        const mappedData = res.data.map((item) => ({
          ...item,
          name: item.serviceName, // Map serviceName to name for Table and Modal
          status: !item.isDisabled, // Map isDisabled to status (Enabled=true)
          id: item._id,
          // Format date if needed, backend sends ISO string
          date: new Date(item.createdAt).toDateString(),
        }));
        setServices(mappedData);
      }
    } catch (error) {
      toast.error("Failed to fetch services");
    }
  };

  useEffect(() => {
    fetchServices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, search]);

  const onCloseModal = () => {
    setIsOpen(false);
    setData({});
  };

  const onEdit = (datas) => {
    setIsOpen(true);
    setData(datas);
  };

  const handleExport = async () => {
    try {
      const blob = await servicesService.exportServicesPdf();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Services-${Date.now()}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    } catch (error) {
      toast.error("Export failed");
    }
  };

  const onDelete = async (item) => {
    try {
      const res = await servicesService.deleteService(item.id);
      if (res.success) {
        toast.success(res.message);
        fetchServices();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      toast.error("Failed to delete service");
    }
  };

  return (
    <Layout>
      {isOpen && (
        <AddEditServiceModal
          datas={data}
          isOpen={isOpen}
          closeModal={onCloseModal}
          onRefresh={fetchServices}
        />
      )}
      {/* add button */}
      <button
        onClick={() => setIsOpen(true)}
        className='flex-colo button-fb fixed bottom-8 right-12 z-50 h-16 w-16 animate-bounce rounded-full border border-border bg-[#0095D9] text-white'
      >
        <BiPlus className='text-2xl' />
      </button>
      {/*  */}
      <h1 className='text-xl font-semibold'>Services</h1>
      <div
        data-aos='fade-up'
        data-aos-duration='1000'
        data-aos-delay='100'
        data-aos-offset='200'
        className='my-8 rounded-xl border-[1px] border-border bg-white p-5'
      >
        {/* datas */}

        <div className='grid grid-cols-1 gap-2 md:grid-cols-6'>
          <div className='grid items-center gap-2 xs:grid-cols-2 md:col-span-5 lg:grid-cols-4'>
            <input
              type='text'
              placeholder='Search "teeth cleaning"'
              className='h-14 w-full rounded-md border border-border bg-dry px-4 text-sm text-main'
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Select
              selectedPerson={status}
              setSelectedPerson={setStatus}
              datas={sortsDatas.service}
            >
              <div className='flex-btn w-full rounded-lg border border-border bg-dry p-4 text-sm font-light text-main focus:border focus:border-[#0095D9]'>
                {status.name} <BiChevronDown className='text-xl' />
              </div>
            </Select>
          </div>

          {/* export */}
          <Button
            label='Export'
            Icon={MdOutlineCloudDownload}
            onClick={handleExport}
          />
        </div>
        <div className='mt-8 w-full overflow-x-scroll'>
          <ServiceTable data={services} onEdit={onEdit} onDelete={onDelete} />
        </div>
      </div>
    </Layout>
  );
}

export default Services;
